import React, { FC } from 'react';
import { FormikProps } from 'formik';
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
  Theme,
  Typography,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { Dollar } from '../utils/formatters';

type CurrencyInputProps = {
  formik: FormikProps<any>;
} & OutlinedInputProps;

const CurrencyInput: FC<CurrencyInputProps> = ({ formik, ...props }) => {
  const { classes } = useStyles();

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    formik.setFieldValue('amount', value);
    formik.setFieldValue('value', value.split(',').join(''));
  }

  function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
    if (parseInt(event.target.value)) {
      const value = Dollar(event.target.value.split(',').join('')).slice(1);

      formik.setFieldValue(event.target.name, value);

      if (value !== '') formik.setFieldTouched('value', true);
    }
  }

  return (
    <div className={classes.root}>
      <FormControl variant="outlined">
        <InputLabel htmlFor="outlined-adornment-password">{props.label}</InputLabel>
        <OutlinedInput
          id="amount"
          name="amount"
          value={formik.values.amount}
          onChange={handleChange}
          onBlur={handleBlur}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          inputProps={{ type: 'currency' }}
          label={props.label}
        />
        <Typography component="strong" color="primary">
          <small>
            {Array.isArray(formik.errors.value)
            ? formik.errors.value.join(', ') // handle array case
            : typeof formik.errors.value === 'string'
            ? formik.errors.value
            : null}
          </small>
        </Typography>
      </FormControl>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) =>
  ({
    root: { backgroundColor: theme.colors.white },
  })
);

export default CurrencyInput;
